/* unplugin-vue-components disabled */import { render } from "./FormText.vue?vue&type=template&id=00493a15&ts=true"
import script from "./FormText.vue?vue&type=script&lang=ts"
export * from "./FormText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__